/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'account': {
    width: 34,
    height: 34,
    viewBox: '0 0 34 34',
    data: '<path pid="0" d="M17 0C7.6 0 0 7.6 0 17s7.6 17 17 17 17-7.6 17-17S26.4 0 17 0zm0 1.9c8.3 0 15.1 6.8 15.1 15.1 0 3-.9 5.8-2.4 8.2-2.8-2.7-7.3-4.3-12.7-4.3-5.4 0-9.9 1.5-12.7 4.3C2.8 22.8 1.9 20 1.9 17 1.9 8.7 8.7 1.9 17 1.9zm0 30.2c-4.6 0-8.7-2.1-11.5-5.4 2.4-2.5 6.5-4 11.5-4s9.1 1.4 11.5 4c-2.8 3.3-6.9 5.4-11.5 5.4zm.2-13.2c3.7 0 6.7-2.9 6.7-6.6 0-3.7-3-6.6-6.7-6.6s-6.7 2.9-6.7 6.6c0 3.7 2.9 6.6 6.7 6.6zm0-11.3c2.6 0 4.8 2.1 4.8 4.7S19.8 17 17.2 17c-2.6 0-4.8-2.1-4.8-4.7s2.1-4.7 4.8-4.7z"/>'
  }
})
